import { render, staticRenderFns } from "./tagSelect.vue?vue&type=template&id=0826fcb6&scoped=true"
import script from "./tagSelect.vue?vue&type=script&lang=js"
export * from "./tagSelect.vue?vue&type=script&lang=js"
import style0 from "./tagSelect.vue?vue&type=style&index=0&id=0826fcb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0826fcb6",
  null
  
)

export default component.exports